export default {
  url_erp: 'https://media.secundo-immo.be',
  url_api: 'https://link.secundo-immo.be/public'
}


// WEBPACK FOOTER //
// ./src/tools/config.js